import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from "styled-components";
import { colors, size, typography } from "../../shared/constants";
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: ", " !important; /* To override wrappers */\n  font-size: 0.875rem;\n  line-height: 1.063rem; /* 17px */\n  letter-spacing: 0.25px;\n  padding: ", "px ", "px;\n  border-radius: ", "px;\n  width: fit-content;\n  color: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n"])), typography.weight.xbold, size.xs2, size.sm, size.xs2, function (_ref) {
  var o = _ref.textColor;
  return o || colors.white;
}, function (_ref2) {
  var o = _ref2.backgroundColor;
  return o;
});